export default class Browser {
  static  redirectPage = "/ie-not-compatible.html";
  constructor() {
    Browser.validate();
  }

  static validate = () => {
    if (!this.isIE()) return;
    window.location.href = this.getRedirectUri();
  };

  static isIE = () => {
    // Internet Explorer 6-11
    //@ts-ignore
    let isIE = /*@cc_on!@*/ false || !!document.documentMode;
    return isIE;
  };

  static getRedirectUri = () => {
    const protocol = window.location.protocol + "//";
    const hostname = window.location.hostname || "";
    const port = window.location.port ? `:${window.location.port}` : "";
    const page = this.redirectPage;
    return protocol + hostname + port + page;
  };
}
